// Mock data for FORUS Transport Booking Application

export const vehicleTypes = [
  {
    id: 'carrosserie',
    name: 'Carrosserie',
    icon: 'truck',
    image: '🚛'
  },
  {
    id: 'fourgon',
    name: 'Fourgon',
    icon: 'van',
    image: '📦'
  },
  {
    id: 'fourgon_frigo',
    name: 'Fourgon frigorifique',
    icon: 'snowflake',
    image: '❄️'
  },
  {
    id: 'plateau',
    name: 'Plateau',
    icon: 'flatbed',
    image: '🚚'
  },
  {
    id: 'porte_char',
    name: 'Porte-char',
    icon: 'trailer',
    image: '🚜'
  },
  {
    id: 'camion_benne',
    name: 'Camion benne',
    icon: 'dump',
    image: '🚧'
  },
  {
    id: 'porte_engins',
    name: 'Camion porte-engins',
    icon: 'construction',
    image: '🏗️'
  },
  {
    id: 'autre',
    name: 'Autre',
    icon: 'plus',
    image: '✨'
  }
];

export const operationTypes = [
  { value: 'transport_marchandises', label: '📦 Transport de marchandises', showContainerOption: false },
  { value: 'livraison_derniere_mile', label: '🏠 Livraison dernière-mile', showContainerOption: false },
  { value: 'collecte', label: '📥 Collecte / Enlèvement sur site', showContainerOption: false },
  { value: 'demenagement', label: '🏡 Déménagement', showContainerOption: false },
  { value: 'transport_btp', label: '🧱 Transport de matériel BTP', showContainerOption: false },
  { value: 'transport_conteneur', label: '📦 Transport de conteneur', showContainerOption: true },
  { value: 'transport_sensible', label: '⚠️ Transport de matériel sensible', showContainerOption: false },
  { value: 'transport_frigo', label: '❄️ Transport frigorifique / chaîne du froid', showContainerOption: false },
  { value: 'transport_interurbain', label: '🛣️ Transport interurbain', showContainerOption: false },
  { value: 'transport_local', label: '🏙️ Transport local (intra-Abidjan)', showContainerOption: false },
  { value: 'transport_regional', label: '🌍 Transport régional (CEDEAO)', showContainerOption: false },
  { value: 'operation_speciale', label: '✨ Opération spéciale (à préciser)', showContainerOption: false }
];

export const merchandiseTypes = [
  { value: 'materiel_btp', label: '🧱 Matériel BTP (fer, ciment, carreaux, sable…)' },
  { value: 'colis_cartons', label: '📦 Colis & cartons' },
  { value: 'mobilier', label: '🪑 Mobilier / Électroménager' },
  { value: 'refrigere', label: '❄️ Marchandises réfrigérées' },
  { value: 'alimentaire', label: '🥫 Produits alimentaires' },
  { value: 'sensible', label: '🧪 Produits sensibles / fragiles' },
  { value: 'industriel', label: '🛠 Matériel industriel' },
  { value: 'pieces_detachees', label: '🚗 Pièces détachées / mécanique' },
  { value: 'consommation', label: '🛒 Produits de consommation' },
  { value: 'textile', label: '👔 Textile / Vêtements' },
  { value: 'produits_chimiques', label: '⚗️ Produits chimiques (non dangereux)' },
  { value: 'bois_materiaux', label: '🪵 Bois & matériaux de construction' },
  { value: 'electronique', label: '💻 Équipements électroniques' },
  { value: 'vehicules', label: '🚗 Véhicules / Engins' },
  { value: 'meubles_demenagement', label: '📦 Meubles / Déménagement' },
  { value: 'produits_agricoles', label: '🌾 Produits agricoles' },
  { value: 'liquides_vrac', label: '🛢 Liquides en vrac (citernes)' },
  { value: 'granulats', label: '⛏ Granulats / Matériaux en vrac' },
  { value: 'autre', label: '✨ Autre (à préciser)' }
];

// Types de conteneurs (liste complète)
export const containerTypes = [
  { 
    value: 'conteneur_20_standard', 
    label: 'Conteneur 20 pieds Standard',
    icon: '📦',
    dimensions: '20\' × 8\' × 8\'6"',
    description: 'Standard - Usage général'
  },
  { 
    value: 'conteneur_40_standard', 
    label: 'Conteneur 40 pieds Standard',
    icon: '📦',
    dimensions: '40\' × 8\' × 8\'6"',
    description: 'Standard - Grand volume'
  },
  { 
    value: 'conteneur_40_hc', 
    label: 'Conteneur 40 pieds High Cube',
    icon: '📦',
    dimensions: '40\' × 8\' × 9\'6"',
    description: 'High Cube - Volume supérieur'
  },
  { 
    value: 'conteneur_45_hc', 
    label: 'Conteneur 45 pieds High Cube',
    icon: '📦',
    dimensions: '45\' × 8\' × 9\'6"',
    description: 'High Cube - Très grand volume'
  },
  { 
    value: 'conteneur_20_frigo', 
    label: 'Conteneur frigorifique 20 pieds',
    icon: '❄️',
    dimensions: '20\' × 8\' × 8\'6"',
    description: 'Réfrigéré - Température contrôlée'
  },
  { 
    value: 'conteneur_40_frigo', 
    label: 'Conteneur frigorifique 40 pieds',
    icon: '❄️',
    dimensions: '40\' × 8\' × 8\'6"',
    description: 'Réfrigéré - Grand volume'
  },
  { 
    value: 'conteneur_40_frigo_hc', 
    label: 'Conteneur frigorifique 40 pieds High Cube',
    icon: '❄️',
    dimensions: '40\' × 8\' × 9\'6"',
    description: 'Réfrigéré - Volume supérieur'
  },
  { 
    value: 'conteneur_20_open_top', 
    label: 'Conteneur Open Top 20 pieds',
    icon: '📂',
    dimensions: '20\' × 8\' × 8\'6"',
    description: 'Toit ouvrant - Chargement par le haut'
  },
  { 
    value: 'conteneur_40_open_top', 
    label: 'Conteneur Open Top 40 pieds',
    icon: '📂',
    dimensions: '40\' × 8\' × 8\'6"',
    description: 'Toit ouvrant - Chargement par le haut'
  },
  { 
    value: 'conteneur_20_flat_rack', 
    label: 'Conteneur Flat Rack 20 pieds',
    icon: '📐',
    dimensions: '20\' × 8\' × 8\'6"',
    description: 'Parois repliables - Charges lourdes'
  },
  { 
    value: 'conteneur_40_flat_rack', 
    label: 'Conteneur Flat Rack 40 pieds',
    icon: '📐',
    dimensions: '40\' × 8\' × 8\'6"',
    description: 'Parois repliables - Charges lourdes'
  },
  { 
    value: 'conteneur_20_plateforme', 
    label: 'Conteneur Plateforme 20 pieds',
    icon: '🏗️',
    dimensions: '20\' × 8\'',
    description: 'Plateforme plate - Charges spéciales'
  },
  { 
    value: 'conteneur_40_plateforme', 
    label: 'Conteneur Plateforme 40 pieds',
    icon: '🏗️',
    dimensions: '40\' × 8\'',
    description: 'Plateforme plate - Charges spéciales'
  },
  { 
    value: 'conteneur_20_citerne', 
    label: 'Conteneur citerne 20 pieds (Tank ISO)',
    icon: '🛢️',
    dimensions: '20\' × 8\' × 8\'6"',
    description: 'Citerne - Liquides / Gaz'
  },
  { 
    value: 'conteneur_20_side_door', 
    label: 'Conteneur à ouverture latérale 20 pieds',
    icon: '🚪',
    dimensions: '20\' × 8\' × 8\'6"',
    description: 'Ouverture latérale - Accès facile'
  },
  { 
    value: 'conteneur_40_side_door', 
    label: 'Conteneur à ouverture latérale 40 pieds',
    icon: '🚪',
    dimensions: '40\' × 8\' × 8\'6"',
    description: 'Ouverture latérale - Accès facile'
  },
  { 
    value: 'conteneur_20_double_porte', 
    label: 'Conteneur double porte 20 pieds',
    icon: '🚪🚪',
    dimensions: '20\' × 8\' × 8\'6"',
    description: 'Double ouverture - Chargement optimisé'
  },
  { 
    value: 'conteneur_40_double_porte', 
    label: 'Conteneur double porte 40 pieds',
    icon: '🚪🚪',
    dimensions: '40\' × 8\' × 8\'6"',
    description: 'Double ouverture - Chargement optimisé'
  },
  { 
    value: 'conteneur_20_ventile', 
    label: 'Conteneur ventilé 20 pieds',
    icon: '💨',
    dimensions: '20\' × 8\' × 8\'6"',
    description: 'Ventilation naturelle - Produits périssables'
  },
  { 
    value: 'conteneur_40_ventile', 
    label: 'Conteneur ventilé 40 pieds',
    icon: '💨',
    dimensions: '40\' × 8\' × 8\'6"',
    description: 'Ventilation naturelle - Produits périssables'
  }
];

export const countries = [
  { value: 'ci', label: 'Côte d\'Ivoire', code: '+225' },
  { value: 'fr', label: 'France', code: '+33' },
  { value: 'sn', label: 'Sénégal', code: '+221' },
  { value: 'ml', label: 'Mali', code: '+223' },
  { value: 'bf', label: 'Burkina Faso', code: '+226' }
];

export const mockAddressSuggestions = [
  'Abidjan, Cocody',
  'Abidjan, Plateau',
  'Abidjan, Yopougon',
  'Abidjan, Marcory',
  'Abidjan, Treichville',
  'Yamoussoukro',
  'Bouaké',
  'San Pedro',
  'Daloa'
];

export const defaultMapCenter = [5.345317, -4.024429]; // Abidjan coordinates
export const defaultZoom = 13;
